// 创建简单的全局状态管理
import Vue from 'vue'

const store = new Vue({
    data() {
        return {
            likedArticles: new Set(), // 已点赞的文章ID集合
            collectedArticles: new Set(), // 已收藏的文章ID集合
            userProfile: {
                name: 'fanfan',
                avatar: '',
                email: 'fanfan0521@yeah.net',

                bio: '啥都不会的杂毛',
                joinDate: '2025-08-14',
                likedCount: 999,
                collectedCount: 999
            }
        }
    },
    methods: {
        // 点赞/取消点赞
        toggleLike(articleId) {
            if (this.likedArticles.has(articleId)) {
                this.likedArticles.delete(articleId)
                this.userProfile.likedCount--
            } else {
                this.likedArticles.add(articleId)
                this.userProfile.likedCount++
            }
        },

        // 收藏/取消收藏
        toggleCollect(articleId) {
            if (this.collectedArticles.has(articleId)) {
                this.collectedArticles.delete(articleId)
                this.userProfile.collectedCount--
            } else {
                this.collectedArticles.add(articleId)
                this.userProfile.collectedCount++
            }
        },

        // 检查是否已点赞
        isLiked(articleId) {
            return this.likedArticles.has(articleId)
        },

        // 检查是否已收藏
        isCollected(articleId) {
            return this.collectedArticles.has(articleId)
        }
    }
})

export default store